import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define the state interface
export interface CardsLoaderState {
  cardsIndex: number;
  column: number;
}

const initialState: CardsLoaderState = {
  cardsIndex: 10,  // Initial value for cardsIndex, assuming 10 is the default
  column: 3        // Default column value
};

export const cardsLoaderSlice = createSlice({
  name: 'cardsLoader',
  initialState,
  reducers: {
    setCardLoader: (state, action: PayloadAction<number | ((prev: number) => number) | { column: number }>) => {
      // Handle different payload types
      if (typeof action.payload === 'function') {
        // If payload is a function that calculates new value based on previous value
        state.cardsIndex = (action.payload as ((prev: number) => number))(state.cardsIndex);
      } else if (typeof action.payload === 'object' && 'column' in action.payload) {
        // If payload is an object with a column property
        state.column = action.payload.column;
      } else if (typeof action.payload === 'number') {
        // If payload is a direct number
        state.cardsIndex = action.payload;
      }
    }
  }
});

export const { setCardLoader } = cardsLoaderSlice.actions;
export default cardsLoaderSlice.reducer;
